import classNames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { getLogoForAccount } from '@pages/Trade/TradingAccountInfo/utils/getLogoForAccount'
import { Account } from '@pages/Trade/types'
import {
  MobileTradeButtonLinkWrapper,
  TradeButtonLinkWrapper,
} from '@pages/Traders-Room/Trading-Accounts/components/TradeButtonLinkWrapper'

import { Body1, Body2, Heading4 } from '@ui/Typography'
import { Button } from '@ui/components/Button'
import { WarningIcon } from '@ui/icons/Warning.icon'

import { useWindowResize } from '@utils/domUtils'

import { Box } from '@shared/components/Box'

import styles from './TradeExternalAccountScreen.module.scss'

type TradeExternalAccountScreenProps = {
  account: Account
  isError?: boolean
}
export const TradeExternalAccountScreen = ({
  account,
  isError = true,
}: TradeExternalAccountScreenProps) => {
  const isMobile = useWindowResize()
  const { t } = useTranslation()

  return (
    <div
      className={classNames(
        styles.tradeExternalAccountScreenContainer,
        isMobile && styles.tradeExternalAccountScreenContainerMobile
      )}
    >
      <div className={styles.openPlatformWrapper}>
        {isError ? (
          <div className={styles.errorContainer}>
            <WarningIcon color={'text-white'} />
          </div>
        ) : (
          <div className={styles.avatar}>
            <div className={styles.logoWrapper}>{getLogoForAccount(account)}</div>
          </div>
        )}
        <Heading4>
          {isError ? t('Markets.SomethingWentWrong') : t('Markets.OpenTradingPlatform')}
        </Heading4>
        {isMobile ? (
          <Body2 align='center' color='text-med-em'>
            {isError
              ? t('Markets.TechnicalIssuesNew')
              : t('Markets.StartTrading', { platform: account.platformType.name })}
          </Body2>
        ) : (
          <Body1 className={styles.text} align='center' color='text-med-em'>
            {isError
              ? t('Markets.TechnicalIssuesNew')
              : t('Markets.StartTrading', { platform: account.platformType.name })}
          </Body1>
        )}
      </div>
      {isMobile ? (
        <Box fullWidth>
          <MobileTradeButtonLinkWrapper tradingAccount={account} size={'lg'} />
        </Box>
      ) : (
        <div className={styles.tradeButtonWrapper}>
          <TradeButtonLinkWrapper disabled={false} tradingAccount={account} size='lg' fullWidth>
            <Button.Primary fullWidth size='lg'>
              {t('Markets.Trade')}
            </Button.Primary>
          </TradeButtonLinkWrapper>
        </div>
      )}
    </div>
  )
}
